export enum BroadcastChannels {
  Logout = 'logout',
  Notification = 'notification',
}

export default function createBroadcastChannel(channel: BroadcastChannels): BroadcastChannel {
  return new BroadcastChannel(channel);
}
